/*jshint esversion: 6 */
// import Vue from 'vue';
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  takt_journal_data: [],
  takt_journal_settings: {
    filter_no_entries: false,
    date_picker: [],
    select_range: true,
  },
});

// State object
const state = initialState();
// Getter functions
const getters = {
  //local variables
  getTaktJournal: (state) => {
    if (state.takt_journal_settings.filter_no_entries) {
      return state.takt_journal_data.filter(entry => entry.workpackages_changed.length !== 0 &&
             state.takt_journal_settings.date_picker.includes(entry.date_string));
    } else {
      return state.takt_journal_data.filter(entry => state.takt_journal_settings.date_picker.includes(entry.date_string));
    }
  },
  getTaktJournalSettings: (state) => {
    return state.takt_journal_settings;
  },
  getTaktJournalDatePickerEntries: (state) => {
    let journal_data_filtered = state.takt_journal_data.filter(entry => entry.workpackages_changed.length !== 0);
    let entries = [];
    for (let i = 0; i < journal_data_filtered.length; i++) {
      entries.push(journal_data_filtered[i].date_string);
    }
    return entries;
  },
  getTaktJournalDatePicker: (state) => {
    let journal_data_filtered = state.takt_journal_data;
    let entries = [];
    for (let i = 0; i < journal_data_filtered.length; i++) {
      entries.push(journal_data_filtered[i].date_string);
    }
    return entries;
  },
};
// Actions
const actions = {
  //local variables
  requestTaktJournalLastWeek({commit, rootGetters}, project_id) {
    return new Promise((resolve) => {
    let data = [];
    let date_picker = [];
    let current_date = new Date();
    let end_date = new Date().setDate(new Date().getDate() - 7);
    let call_data = {
      dates: [],
      indices: [],
      show_status: true,
      show_comments: true,
      show_steps: true,
      show_images: true,
      show_other_changes: true,
    };
    while (current_date >= end_date) {
      let date = rootGetters['ProjectCalendar/getNewDate'](current_date);
      let date_string = `${date.getFullYear()}-${date.getMonth()+1<10?0:''}${date.getMonth()+1}-${date.getDate()<10?0:''}${date.getDate()}`;
      data.push({
        date: date,
        date_string: date_string,
        workpackages_changed: [],
        wps_ready: [],
        wps_started: [],
        wps_done: [],
        wps_checked: [],
        wps_closed: [],
        wps_stop: [],
      });
      date_picker.push(date_string);
      call_data.dates.push(date_string);
      call_data.indices.push(rootGetters['ProjectCalendar/getTaktIndexFromDate']({
        project_id: project_id,
        date_string: date_string
      }).index);
      current_date.setDate(current_date.getDate() - 1);
    }
    axios({
        url: '/projects/' + project_id +
            '/constructiondiaries',
        method: 'POST',
        data: call_data,
        headers: {
          'cache-control': 'no-cache'
        },
      })
    .then(response => {
        for (let i = 0; i < response.data.data.length; i++) {
          Object.assign(data.find(element => element.date_string === response.data.data[i].date_string), response.data.data[i]);
        }
        commit('set_takt_journal_data', {
        data: data,
        });
        commit('set_takt_journal_settings', {
          date_picker: date_picker,
        });
        resolve();
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  });
},
  requestTaktJournalByDates({commit, rootGetters}, payload) {
  return new Promise((resolve) => {
  let data = [];
  let date_picker = [];
  let current_date;
  let end_date;

  if (payload.dates.length == 2) {
    let date1 = new Date(payload.dates[0]);
    let date2 = new Date(payload.dates[1]);
    if (date1 < date2) {
      current_date = date2;
      end_date = date1;
    } else {
      current_date = date1;
      end_date = date2;
    }
  } else if (payload.dates.length == 1) {
    current_date = new Date(payload.dates[0]);
    end_date = new Date(payload.dates[0]);
  } else {
    let date1 = new Date(payload.dates[0]);
    let date2 = new Date(payload.dates[payload.dates.length-1]);
    if (date1 < date2) {
      current_date = date2;
      end_date = date1;
    } else {
      current_date = date1;
      end_date = date2;
    }
  }

  let call_data = {
    dates: [],
    indices: [],
    show_status: payload.show_status,
    show_comments: payload.show_comments,
    show_steps: payload.show_steps,
    show_images: payload.show_images,
    show_other_changes: payload.show_other_changes,
  };

  while (current_date >= end_date) {
    let date = rootGetters['ProjectCalendar/getNewDate'](current_date);
    let date_string = `${date.getFullYear()}-${date.getMonth()+1<10?0:''}${date.getMonth()+1}-${date.getDate()<10?0:''}${date.getDate()}`;
    data.push({
      date: date,
      date_string: date_string,
      workpackages_changed: [],
      wps_ready: [],
      wps_started: [],
      wps_done: [],
      wps_checked: [],
      wps_closed: [],
      wps_stop: [],
    });
    date_picker.push(date_string);
    call_data.dates.push(date_string);
    call_data.indices.push(rootGetters['ProjectCalendar/getTaktIndexFromDate']({
      project_id: payload.project_id,
      date_string: date_string
    }).index);
    current_date.setDate(current_date.getDate() - 1);
  }

  axios({
      url: '/projects/' + payload.project_id +
          '/constructiondiaries',
      method: 'POST',
      data: call_data,
      headers: {
        'cache-control': 'no-cache'
      },
    })
  .then(response => {
      for (let i = 0; i < response.data.data.length; i++) {
        Object.assign(data.find(element => element.date_string === response.data.data[i].date_string), response.data.data[i]);
      }
      commit('set_takt_journal_data', {
      data: data,
      });
      commit('set_takt_journal_settings', {
        date_picker: date_picker,
      });
      resolve();
  })
  .catch(err => {
    commit('set_error', extractErrorDetails(err));
  });
});
},
  setTaktJournalSettings({commit}, payload) {
    commit('set_takt_journal_settings', payload);
  },
  setTaktJournalSettingsDatePicker({commit, rootGetters}, payload) {
    let payload_cache = JSON.parse(JSON.stringify(payload));
    let settings = state.takt_journal_settings;
    if (settings.select_range && payload.length === 2){
    var start_date = rootGetters['ProjectCalendar/getNewDate'](payload[0]);
    var current_date = rootGetters['ProjectCalendar/getNewDate'](start_date);
    var end_date = rootGetters['ProjectCalendar/getNewDate'](payload[1]);

    if (start_date.getTime() < end_date.getTime()) {
      current_date.setDate(current_date.getDate() + 1);
      while (current_date < end_date) {
        let date = rootGetters['ProjectCalendar/getNewDate'](current_date);
        payload_cache.push(date.toISOString().substring(0, 10));
        current_date.setDate(current_date.getDate() + 1);
      }
    } else {
      current_date.setDate(current_date.getDate() - 1);
      while (current_date > end_date) {
        let date = rootGetters['ProjectCalendar/getNewDate'](current_date);
        payload_cache.push(date.toISOString().substring(0, 10));
        current_date.setDate(current_date.getDate() - 1);
      }
    }
  }
  payload_cache = payload_cache.sort();
  commit('set_takt_journal_settings_date_picker', payload_cache);
  },
};
// Mutations
const mutations = {
  //locale state mutation
  set_takt_journal_data(state, payload) {
    state.takt_journal_data = payload.data;
  },
  set_takt_journal_settings(state, payload) {
    for (let prop in payload) {
      state.takt_journal_settings[prop] = payload[prop];
    }
  },
  set_takt_journal_settings_date_picker(state, payload) {
    state.takt_journal_settings.date_picker = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
